import {Controller} from "react-hook-form";
import {HubTextField, HubTextFieldProps} from "./TextField";
import React from "react";

type HookFieldProps = {
    name: string;
    control: any;
    rules?: any;
    defaultValue?: any;
} & HubTextFieldProps;

type AriaFieldProps = {
    onChange: any,
    value: string
} & HubTextFieldProps;

type HookTextFieldProps = (HookFieldProps | AriaFieldProps) & {isLoading?: boolean};

export const HookTextField = (props: HookTextFieldProps) => {

    if ('onChange' in props && 'value' in props) {
        return (
            <HubTextField {...props} />
        )
    }
    else if (props && 'control' in props && 'name' in props) {
        const { name, control, defaultValue="", rules={}, ...rest} = props;
        return (
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                render={({
                             field,
                             fieldState: { invalid, error }
                         }) => (
                    <HubTextField
                        {...field}
                        invalid={invalid}
                        error={error}
                        {...rest}
                    />
                )}
                rules={rules}
            />
        )
    }
    else {
        throw new Error('Invalid props for HookTextField');
    }
}
